import { render, staticRenderFns } from "./FormStep_Loader.vue?vue&type=template&id=1cf0459a&"
import script from "./FormStep_Loader.vue?vue&type=script&lang=js&"
export * from "./FormStep_Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports